<template>
    <v-container max-width="100%" :style="embedded ? 'padding: 0' : 'margin-top: 2%;'">
        <!-- Dialog fora de v-row: a margem negativa da linha vazia colava a tabela no topo. -->
        <v-dialog v-model="confirmDialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">
                    <span style="color: #d60000">{{ $t('system.alert') }}</span>
                </v-card-title>
                <v-card-text>
                    <span style="color: #d60000">{{ mensagemdialog }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                        $t('button.dismiss') }}</v-btn>
                    <v-btn color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                        $t('button.confirm') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <merus-data-table :headers="headers" :items="firmwares" :loading="loadingtable"
            :loading-text="$t('isapiFirmwares.loading')" @update:displayedItems="displayedItemsForExport = $event"
            cod-tabela="ISAPIFIRMWARES" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('isapiFirmwares.title')" :token="token"
                    :items="displayedItemsForExport !== null ? displayedItemsForExport : firmwares"
                    :csv-title="$t('isapiFirmwares.title')" :pdf-title="$t('isapiFirmwares.title')"
                    :pdf-headers="headers" :pdf-filename="$t('isapiFirmwares.title')" hide-search>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ $t('isapiFirmwares.self') }}</v-toolbar-title>
                                    <AjudaTooltip class="ml-2" color="white" :texto="$t('isapiFirmwares.caption')" />
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field v-model="editedItem.firmware_version"
                                                        :label="$t('isapiFirmwares.firmwareVersion')"
                                                        counter="50" :rules="regrasFirmware">
                                                        <template v-slot:append-outer><AjudaTooltip :texto="$t('isapiFirmwares.firmwareVersionHint')" /></template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field v-model="editedItem.firmware_released_date"
                                                        :label="$t('isapiFirmwares.firmwareReleasedDate')"
                                                        counter="50" :rules="regrasFirmware">
                                                        <template v-slot:append-outer><AjudaTooltip :texto="$t('isapiFirmwares.firmwareReleasedDateHint')" /></template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="9" md="9">
                                                    <v-text-field v-model="editedItem.descricao"
                                                        :label="$t('isapiFirmwares.description')" counter="255"
                                                        :rules="[(v) => !v || v.length <= 255 || $t('isapiFirmwares.validation.descriptionMaxLength')]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-switch v-model="editedItem.ativo" :true-value="1" :false-value="0"
                                                        :label="$t('isapiFirmwares.active')"
                                                        >
                                                        <template v-slot:append-outer><AjudaTooltip :texto="$t('isapiFirmwares.activeHint')" /></template>
                                                    </v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="primary" @click="close">{{ $t('button.cancel') }}</v-btn>
                                    <v-btn dark color="primary" @click="save">{{ $t('button.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>
            </template>
            <template v-slot:item.ativo_extenso="{ item }">
                <v-chip small dark :color="item.ativo == 1 ? 'green' : 'grey'">{{ item.ativo_extenso }}</v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "../../Tables/MerusDataTable.vue";
import CadastroToolbar from "../../Toolbars/CadastroToolbar.vue";
import EventBus from "@/utils/eventBus";
import AjudaTooltip from "../AjudaTooltip.vue";

const ITEM_VAZIO = {
    id_firmware_permitido: null,
    firmware_version: null,
    firmware_released_date: null,
    descricao: null,
    ativo: 1,
};

// Firmwares (versão + build) em que o ISAPI alcança o FaceID. A rotina só atualiza o
// aparelho cujo firmware efetivo (do DVR Hinova ou do cadastro) está ativo nesta lista.
export default {
    name: 'FirmwaresPermitidos',
    components: {
        MerusDataTable,
        CadastroToolbar,
        AjudaTooltip
    },
    props: {
        // Dentro da aba Validadores da tela de Equipamentos: sem a margem de tela própria.
        embedded: { type: Boolean, default: false },
    },
    data: () => ({
        headers: [],
        displayedItemsForExport: null,
        firmwares: [],
        loadingtable: true,
        confirmDialog: false,
        mensagemdialog: "",
        formValidado: true,
        dialog: false,
        editedIndex: -1,
        editedItem: { ...ITEM_VAZIO },
        deletedItem: { ...ITEM_VAZIO },
        operacao: 0,
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    computed: {
        regrasFirmware() {
            return [
                (v) => !!(v && String(v).trim()) || this.$t('isapiFirmwares.validation.required'),
                (v) => !v || v.length <= 50 || this.$t('isapiFirmwares.validation.firmwareMaxLength'),
            ];
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    methods: {
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                this.canEdit = true;
                this.canInsert = true;
                this.canDelete = true;
                this.initialize();
                return;
            }
            apiController.request(apiController.endpoints.getRecursosusuario, {
                params: { id: this.user.id_usuario },
                onSuccess: (response) => {
                    const recursos = response.data || [];
                    this.canEdit = recursos.some((r) => r.rota === "/api/v1.0/isapi/updatefirmwarepermitido");
                    this.canInsert = recursos.some((r) => r.rota === "/api/v1.0/isapi/insertfirmwarepermitido");
                    this.canDelete = recursos.some((r) => r.rota === "/api/v1.0/isapi/deletefirmwarepermitido");
                    this.initialize();
                },
            });
        },
        initialize() {
            apiController.request(apiController.endpoints.isapiGetallFirmwarespermitidos, {
                silent: true,
                onSuccess: (response) => {
                    this.firmwares = (response.data || []).map((f) => ({
                        ...f,
                        ativo_extenso: f.ativo == 1 ? this.$t('system.yes') : this.$t('system.no'),
                    }));
                    this.loadingtable = false;
                },
                onError: () => {
                    this.loadingtable = false;
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = { ...ITEM_VAZIO };
                this.editedIndex = -1;
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            });
        },
        editItem(item) {
            this.editedIndex = this.firmwares.indexOf(item);
            this.editedItem = { ...item };
            this.dialog = true;
        },
        deleteItem(item) {
            this.deletedItem = { ...item };
            this.mensagemdialog = this.$t('isapiFirmwares.confirmDelete', {
                version: item.firmware_version,
                releasedDate: item.firmware_released_date,
                count: item.qtd_equipamentos || 0,
            });
            this.confirmDialog = true;
        },
        deleteFromDatabase() {
            this.operacao = 2;
            apiController.request(apiController.endpoints.isapiDeleteFirmwarepermitido, {
                data: { id_firmware_permitido: this.deletedItem.id_firmware_permitido },
                onSuccess: (response) => {
                    this.confirmDialog = false;
                    this.updateTable(response.data.erro);
                },
                onError: () => {
                    this.confirmDialog = false;
                },
            });
        },
        save() {
            this.$refs.form.validate();
            if (!this.formValidado) return;
            const opcoes = {
                data: this.editedItem,
                onSuccess: (response) => {
                    this.updateTable(response.data.erro);
                },
            };
            if (this.editedIndex == -1) {
                this.operacao = 0;
                apiController.request(apiController.endpoints.isapiInsertFirmwarepermitido, opcoes);
            } else {
                this.operacao = 1;
                apiController.request(apiController.endpoints.isapiUpdateFirmwarepermitido, opcoes);
            }
        },
        updateTable(erro) {
            const acao = ['insert', 'update', 'delete'][this.operacao];
            EventBus.$emit('show-alert', {
                mensagem: this.$t(`isapiFirmwares.alerts.${erro ? 'error' : 'success'}.${acao}`),
                tipo: erro ? 'error' : 'success',
            });
            this.close();
            this.initialize();
        },
    },
}
</script>
